'use client'
import React from 'react'
import HelperButton from '../HelperButton'
import { Label } from '../Label'
import { InputProps } from '../types'
import styles from './styles.module.scss'

const InputText: React.FC<InputProps> = ({
  placeholder,
  labelText,
  isDisabled,
  helperButton,
  hasError,
  tooltip,
  mode = 'dark',
  innerRef = null,
  withRequiredLabel = false,
  ...props
}) => {
  return (
    <div
      className={`${styles.inputWrapper} ${
        labelText ? styles.inputWrapperWithLabel : ''
      }`}
    >
      {labelText && (
        <Label htmlFor={props.name}>
          {labelText}{' '}
          {withRequiredLabel && <span className={styles.requiredLabel}>*</span>}
        </Label>
      )}
      <div>
        <input
          className={`${styles.input} ${mode === 'dark' ? styles.dark : ''} ${
            helperButton?.type === 'error' || hasError ? styles.error : ''
          }`}
          autoComplete={props.name}
          {...props}
          placeholder={labelText ? '' : placeholder}
          disabled={isDisabled}
          ref={innerRef}
        />
        {helperButton && <HelperButton {...helperButton} tooltip={tooltip} />}
      </div>
    </div>
  )
}

export default InputText
